import {get, post, deleteApi, postJson, patch} from '../axios'

const RESOURCE_BASE_PATH = '/autoMarketing'

// 获取活动列表
export const getActivityList = p => get(`${RESOURCE_BASE_PATH}/activity/page`, p);

// 查询活动记录列表
export const getTaskPage = p => get(`${RESOURCE_BASE_PATH}/task/page`, p);

// 删除活动
export const deleteMarket = p => deleteApi(`${RESOURCE_BASE_PATH}/${p}`);

// 查询活动效果分析
export const getEffectMarket = p => get(`${RESOURCE_BASE_PATH}/effect`, p);

// 客户营销-创建活动
export const createMarketing = p => postJson(`${RESOURCE_BASE_PATH}/`, p);

// 客户营销-停止活动
export const stopActivity = p => patch(`${RESOURCE_BASE_PATH}/${p}`);

// 客户营销-查看单个活动
export const catchActivity = p => get(`${RESOURCE_BASE_PATH}/${p}`);